<ng-template [ngIf]="loading"
             [ngIfElse]="loadUsers">
    <loader class="st-manage-team-members-loader"
            [productLabel]="languageSettings.PSTWebLoadingLabel"
            [diameter]="200"
            [strokeWidth]="10"></loader>
</ng-template>
<ng-template #loadUsers>
    <mat-tab-group animationDuration="0ms"
                   (selectedTabChange)="onTabChanged($event)">
        <mat-tab *ngFor="let item of userGroups[groupByField]?.keys; let i = index">
            <ng-template matTabLabel>
                <div class="st-manage-team-members-tab-label">
                    {{item?.display}}
                </div>
                <div class="st-manage-team-members-tab-counter">
                    {{'(' + userGroups[groupByField].entries[item.value]?.length + ')'}}
                </div>
            </ng-template>

            <table mat-table
                   class="st-manage-team-members-tab-table"
                   [dataSource]="userGroups[groupByField].getItemsForCurrentPage(item.value)">
                <ng-container matColumnDef="Avatar">
                    <th mat-header-cell
                        *matHeaderCellDef>{{''}}</th>
                    <td mat-cell
                        *matCellDef="let user">
                        <avatar big
                                [userId]="user.UserID"></avatar>
                    </td>
                </ng-container>
                <ng-container matColumnDef="ID">
                    <th mat-header-cell
                        *matHeaderCellDef>{{languageSettings.PSTWebUserHeaderIDLabel}}</th>
                    <td mat-cell
                        *matCellDef="let user"
                        [class.is-disabled]="!user.Active">
                        {{user.UserID}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="First Name">
                    <th mat-header-cell
                        *matHeaderCellDef>{{languageSettings.PSTWebUserHeaderFirstNameLabel}}</th>
                    <td mat-cell
                        *matCellDef="let user">
                        <text-field [value]="user.GivenName"
                                    [disabled]="!user.Active"
                                    class="st-manage-team-members-tab-table__text-field"
                                    (changed)="valueChanged(user, $event, PSTFieldNames.UserInfoGivenName )">
                        </text-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Last Name">
                    <th mat-header-cell
                        *matHeaderCellDef>{{languageSettings.PSTWebUserHeaderLastNameLabel}}</th>
                    <td mat-cell
                        *matCellDef="let user">
                        <text-field class="st-manage-team-members-tab-table__text-field"
                                    [value]="user.Surname"
                                    [disabled]="!user.Active"
                                    (changed)="valueChanged(user, $event, PSTFieldNames.UserInfoSurname)">
                        </text-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Email">
                    <th mat-header-cell
                        *matHeaderCellDef>{{languageSettings.PSTWebUserHeaderEmailLabel}}</th>
                    <td mat-cell
                        [matTooltip]="user.Email"
                        *matCellDef="let user">
                        <text-field class="st-manage-team-members-tab-table__text-field"
                                    [value]="user.Email"
                                    [disabled]="!user.Active"
                                    (changed)="valueChanged(user, $event, PSTFieldNames.UserInfoEmail )">
                        </text-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="SSO Logins">
                    <th mat-header-cell
                        *matHeaderCellDef>{{languageSettings.PSTWebUserHeaderSSOEmailLabel}}</th>
                    <td mat-cell
                        [matTooltip]="user.SSOLogins"
                        *matCellDef="let user">
                        <text-field class="st-manage-team-members-tab-table__text-field"
                                    [value]="user.SSOLogins"
                                    [disabled]="!user.Active"
                                    (changed)="valueChanged(user, $event, PSTFieldNames.UserInfoSSOLogins )">
                        </text-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Default Team">
                    <th mat-header-cell
                        *matHeaderCellDef>{{languageSettings.PSTWebUserHeaderDefaultTeamLabel}}</th>
                    <td mat-cell
                        *matCellDef="let user">
                        <mat-select [(ngModel)]="user.Program"
                                    class="st-manage-team-members-tab-table__mat-select"
                                    [disabled]="!user.Active"
                                    (selectionChange)="saveMember(user)">
                            <mat-option *ngFor="let program of programs"
                                        [value]="program.ID">
                                {{program.Description}}
                            </mat-option>
                        </mat-select>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Role">
                    <th mat-header-cell
                        *matHeaderCellDef>{{languageSettings.PSTWebUserHeaderRoleLabel}}</th>
                    <td mat-cell
                        *matCellDef="let user">
                        <mat-select [(ngModel)]="user.GlobalRole"
                                    class="st-manage-team-members-tab-table__mat-select"
                                    (selectionChange)="selectRole(user)"
                                    [disabled]="!user.Active">
                            <mat-option *ngFor="let role of roles"
                                        [value]="role.ID">
                                {{role.Description}}
                            </mat-option>
                        </mat-select>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Status">
                    <th mat-header-cell
                        *matHeaderCellDef>{{languageSettings.PSTWebUserHeaderStatusLabel}}</th>
                    <td mat-cell
                        *matCellDef="let user">
                        <mat-select [(ngModel)]="user.Active"
                                    class="st-manage-team-members-tab-table__mat-select"
                                    (selectionChange)="saveMember(user)">
                            <mat-option *ngFor="let item of InvitationStatusCodes.ACTIVE_STATUS_VALUES"
                                        [value]="item.value">
                                {{item.label}}
                            </mat-option>
                        </mat-select>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Invitation Status">
                    <th mat-header-cell
                        *matHeaderCellDef>{{''}}</th>
                    <td mat-cell
                        *matCellDef="let user">
                        <button class="st-manage-team-members-button-invite"
                                [class.st-manage-team-members-button-invite-disabled]="user.InvitationStatus == InvitationStatusCodes.ACTIVE || !user.Email"
                                [disabled]="user.InvitationStatus == InvitationStatusCodes.ACTIVE || !user.Email"
                                (click)="sendInvitation(user)">
                            {{invitationButtonLabel(user)}}
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Delete">
                    <th mat-header-cell
                        *matHeaderCellDef>{{''}}</th>
                    <td mat-cell
                        *matCellDef="let user">
                        <button mat-icon-button
                                (click)="deleteItem(user)">
                            <mat-icon class="st-manage-team-members-button--delete">delete_outline</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row
                    *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: displayedColumns; let odd = odd;"
                    [class.is-odd]="odd"></tr>
            </table>
        </mat-tab>
    </mat-tab-group>
</ng-template>

<ng-template #mainCta>
    <mat-button-toggle-group class="st-manage-team-members-main-cta-button-group">
        <mat-button-toggle class="st-manage-team-members-button-new-member"
                           (click)="openNewMemberDialog()">
            <mat-icon class="material-symbols-outlined">
                add
            </mat-icon>
            {{languageSettings.PSTWebNewMemberLabel}}
        </mat-button-toggle>
    </mat-button-toggle-group>
</ng-template>
<ng-template #viewOptions>
    <ng-container>
        <list-drop-down *ngIf="predefineFilters.sorting"
                        class="left"
                        (valueOutput)="sortByField = $event"
                        [label]="languageSettings?.PSTWebSortByLabel"
                        [value]="sortByField"
                        mobileIcon="sort"
                        [list]="predefineFilters.sorting">
        </list-drop-down>
    </ng-container>
</ng-template>
<ng-template #rightSlot>
    <mat-paginator class="st-manage-team-members-paginator"
                   [pageSize]="pageSize"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   [length]="userGroups[groupByField]?.entries[currentGroup]?.length"
                   (page)="onPageChanged(currentGroup, $event)">
    </mat-paginator>
</ng-template>